/**
 * Stories implemented
 */
/* eslint-disable local-rules/require-storybook-documentation */
import { Text, Banner, CloseButton } from '@zillow/constellation';
import { FC, FunctionComponent } from 'react';
import { useLogoutBannerState } from './useLogoutBannerState';
import { StyledSignin } from './components/StyledSignin';

type LogoutBannerProps = {
    shouldRender: boolean;
    /**
     * Callback for when the user clicks on the close button
     */
    onClose: () => void;
    /**
     * Callback for when the user clicks on sign-in again.
     */
    onSignInClick: () => void;
};
export const LogoutBanner: FunctionComponent<LogoutBannerProps> = ({ shouldRender, onClose, onSignInClick }) => {
    if (!shouldRender) {
        return null;
    }

    return (
        <Banner
            onClose={onClose}
            appearance="warning"
            body={
                <>
                    <Text suppressHydrationWarning>Your session has expired. Please sign in again to continue.</Text>
                    <StyledSignin suppressHydrationWarning onClick={onSignInClick}>
                        Sign in
                    </StyledSignin>
                </>
            }
            closeButton={<CloseButton suppressHydrationWarning />}
            suppressHydrationWarning
        />
    );
};

/**
 * Listens on the Auth events bus for logout or login events. On logout, it renders and shows the session has expired
 * banner. If closed by the user or if a login event occurs, it will hide itself. The banner can persist across page loads
 * through use of sessionStorage.
 */
export const WiredLogoutBanner: FC<{ onSignInClick: () => void; storageKey: string }> = ({
    onSignInClick,
    storageKey,
}) => {
    const { shouldRender, setShouldRender } = useLogoutBannerState(storageKey);

    return (
        <LogoutBanner
            onSignInClick={onSignInClick}
            shouldRender={!!shouldRender}
            onClose={() => setShouldRender(false)}
        />
    );
};
